module.exports = __webpack_public_path__ + "static/Figjam-to-Uizard-a5bd528b2519db26f4e3542435b6101d.png";